<template>
  <v-card class="account-box">
    <v-card-title>
      <span class="title font-weight-light">Change Password</span>
    </v-card-title>

    <v-card-text>
      <v-form ref="changePasswordForm" lazy-validation>
        <!-- Old Password -->
        <v-text-field
          type="password"
          outline
          prepend-inner-icon="lock"
          v-model="changePasswordForm.old_password"
          hint="Password must be at least 8 characters"
          :rules="rules.password"
          label="Old Password"
          single-line
          :error-messages="errors.old_password"
        />

        <!-- Password -->
        <v-text-field
          type="password"
          outline
          prepend-inner-icon="lock"
          v-model="changePasswordForm.password"
          hint="Password must be at least 8 characters"
          :rules="rules.password"
          label="New Password"
          single-line
          :error-messages="errors.password"
        />

        <!-- Confirm Password -->
        <v-text-field
          type="password"
          outline
          prepend-inner-icon="lock"
          v-model="changePasswordForm.password_confirmation"
          hint="Password must be at least 8 characters"
          :rules="rules.password"
          label="New Password Confirmation"
          single-line
        />

        <!-- Submit -->
        <div style="text-align: end">
          <v-btn
            depressed
            @click="
              reset();
              $emit('change');
            "
          >
            Cancel
          </v-btn>

          <v-btn
            class="reset-password-button"
            :loading="loading"
            color="primary"
            dark
            depressed
            @click="submitForm('changePasswordForm')"
            style="margin: 0"
          >
            Update Password
          </v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      changePasswordForm: {
        old_password: "",
        password: "",
        password_confirmation: ""
      },

      loading: false,
      errors: {},

      rules: {
        password: [
          v => !!v || "Password is required",
          v => v.length >= 8 || "Password must be at least 8 characters"
        ]
      }
    };
  },

  methods: {
    submitForm(formName) {
      if (this.$refs[formName].validate()) {
        this.requestChangePassword(this.changePasswordForm);
      }
    },

    async requestChangePassword(req) {
      this.loading = true;

      try {
        this.loading = true;
        this.errors = {};

        const res = await api.changePassword(req);

        this.$notify({
          type: "success",
          title: res.data.message
        });

        this.reset();
        this.$emit("change");
      } catch (error) {
        if (error.errors) {
          this.errors = error.errors;
        } else {
          this.$notify({
            type: "error",
            title: error.message
          });
        }
      } finally {
        this.loading = false;
      }
    },

    reset() {
      this.changePasswordForm = {
        old_password: "",
        password: "",
        password_confirmation: ""
      };
    }
  }
};
</script>
